import Model from "./Model.js";

/**
 * Bag holding a set of transactions.
 *
 * @param {transaction[]}spec.transactions - List of transactions
 */
export default class TransactionList extends Model {
	constructor({ transactions } = {}) {
		super(...arguments);

		this._transactions = transactions || [];

		this._firstTransactionDate = Math.min(
			this._transactions.map((transaction) => transaction.getDate()),
		);

		this._lastTransactionDate = Math.max(
			this._transactions.map((transaction) => transaction.getDate()),
		);

		this._sumDebit = this._transactions.reduce(
			(accumulatedSum, currentTransaction) => {
				const currentAmount = currentTransaction.getAmount();
				return accumulatedSum + (currentAmount > 0 ? currentAmount : 0);
			},
			0,
		);

		this._sumCredit = this._transactions.reduce(
			(accumulatedSum, currentTransaction) => {
				const currentAmount = currentTransaction.getAmount();
				return accumulatedSum + (currentAmount < 0 ? currentAmount : 0);
			},
			0,
		);
	}

	getTransactions() {
		return this._transactions.slice();
	}

	getFirstTransactionDate() {
		return this._firstTransactionDate;
	}

	getLastTransactionDate() {
		return this._lastTransactionDate;
	}

	getSumCredit() {
		return this._sumCredit;
	}

	getReversedSumCredit() {
		return this._reverse(this.getSumCredit());
	}

	getSumDebit() {
		return this._sumDebit;
	}

	getLedgerEntry() {
		return this._transactions[0] && this._transactions[0].getLedgerEntry();
	}

	hasTransaction() {
		return this._transactions.length > 0;
	}

	_reverse(amount) {
		return 0 - amount;
	}
}
